import { startOfToday } from 'date-fns';

import { getTranslatable } from '_i18n';

import type { AsyncEnrollment } from '../../enrollments/types';
import { useLocale } from '../../global/hooks/locale';
import { getEnv } from '../../global/config/env';
import { DEFAULT_TRACK } from '../../enrollments/mappers';

export const useAsyncCardInfos = (enrollment: AsyncEnrollment) => {
    const { asyncUrl } = getEnv();

    const locale = useLocale();

    const ctaLabel = (() => {
        // cta labels are different between discovery and skill course
        if (enrollment.isCompleted) return `${enrollment.trainingType}.restart`;
        if (enrollment.isStarted) return `${enrollment.trainingType}.continue`;
        return `${enrollment.trainingType}.start`;
    })();

    // async training are not available before the starts_on date
    const isAvailable = enrollment.startsOn <= startOfToday();
    const track = enrollment.track;
    return {
        ctaLabel,
        trainingUrl: `${asyncUrl}/trainings/${enrollment.programId}`,
        isAvailable,
        name: enrollment.name,
        loading: false,
        color: track?.color ?? DEFAULT_TRACK.color,
        track: getTranslatable(track.name, locale),
        trainingType: enrollment.trainingType
    };
};
